import * as React from 'react';

import type { InformationCardToggleProps } from 'bundles/program-common/components/InformationCard/InformationCardToggle';
import InformationCardToggle from 'bundles/program-common/components/InformationCard/InformationCardToggle';

import _t from 'i18n!nls/program-common';

type Props = Omit<InformationCardToggleProps, 'label' | 'trackingName'>;

const HowItWorksInformationLink: React.FC<Props> = (props) => (
  <InformationCardToggle {...props} label={_t('How it works')} trackingName="how_it_works_information_link" />
);

export default HowItWorksInformationLink;
